// extracted by mini-css-extract-plugin
module.exports = {"locl-hirer-mobile-banner":"hirer-mobile-banner_locl-hirer-mobile-banner__wjk2g"};